import { pickBy } from 'lodash';

export function filterNullFromObject(obj?: Record<string, any>) {
  if (!obj) return undefined;
  return pickBy(obj, (value) => value !== null);
}
